import { Organization } from '@generated/graphql';
import { calculateDateDifference } from '@helper-functions/calculateDateDifference';
import { ExpiredModal, ExpiringSoonModal } from '@subsets/landing-page/organization/expiration';
import { useEffect, useState } from 'react';

const getExpirationModalData = () => {
  const expirationModalData = JSON.parse(
    localStorage.getItem('expirationModal') || '[]',
  ) as string[];
  return expirationModalData;
};

type OrganizationExpirationModalProps = {
  expirationDate?: Organization['expirationDate'];
  role?: Organization['role'];
  expired?: Organization['expired'];
  organizationId?: Organization['organizationId'];
  name?: Organization['name'];
};

export const OrganizationExpirationWrapper = ({
  expirationDate,
  role,
  expired,
  organizationId,
  name,
}: OrganizationExpirationModalProps) => {
  const [expirationModalShown, setExpirationModalShown] = useState(() => {
    const expirationModalData = getExpirationModalData();
    return Boolean(expirationModalData.find((item) => item === organizationId));
  });

  useEffect(() => {
    const expirationModalData = getExpirationModalData();
    setExpirationModalShown(Boolean(expirationModalData.find((item) => item === organizationId)));
  }, [organizationId]);

  const onModalClose = () => {
    setExpirationModalShown(true);
    const expirationModalData = getExpirationModalData();
    localStorage.setItem(
      'expirationModal',
      JSON.stringify([...expirationModalData, organizationId]),
    );
  };
  const { days } = calculateDateDifference(expirationDate);

  if (role === 'admin' && !expired && days < 8 && !expirationModalShown) {
    return (
      <ExpiringSoonModal
        days={days}
        organizationId={organizationId}
        name={name}
        onClose={onModalClose}
      />
    );
  }

  if (expired) {
    return <ExpiredModal organizationId={organizationId} name={name} />;
  }
  return null;
};
